export const ensure = <T>(value: T | undefined | null, message = 'This value was promised to be there.'): T => {
  if (value === undefined || value === null) {
    throw new TypeError(message);
  }

  return value;
};
